import React from 'react';
import ConfirmDialog from './ConfirmDialog';

/**
 * Çıkış için ConfirmDialog ön ayarları (turuncu uyarı ikonu + kırmızı onay düğmesi).
 */
const LogoutConfirmDialog = ({
  open,
  onCancel,
  onConfirm,
  title = 'Çıkış yapılsın mı?',
  message = 'Oturumunuz kapatılır; devam etmek istediğinize emin misiniz?',
  confirmLabel = 'Çıkış yap',
  cancelLabel = 'İptal',
}) => (
  <ConfirmDialog
    open={open}
    onCancel={onCancel}
    onConfirm={onConfirm}
    title={title}
    message={message}
    variant="warning"
    iconClass="fas fa-sign-out-alt"
    confirmLabel={confirmLabel}
    cancelLabel={cancelLabel}
    confirmButtonClassName="btn danger-btn"
  />
);

export default LogoutConfirmDialog;
